import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/api.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-confirm-dialog-consulta-duplicada',
  templateUrl: './confirm-dialog-consulta-duplicada.component.html',
  styleUrls: ['./confirm-dialog-consulta-duplicada.component.scss']
})
export class ConfirmDialogConsultaDuplicadaComponent {
  pasos: any;
  respuesta: any;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogConsultaDuplicadaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private apiService: ApiService,

  ) {
    this.pasos = [{
      "P1": {
        //*DevFun* Init
        "I": true,
        "CurrentNum": true
      },
      "P2": {
        "I": false,
        "CurrentNum": false
      },
      "P3": {
        "I": false,
        "CurrentNum": false
      }
    }]
  }

  onContinue(): void {
    let data = this.data;
    
    if (data.formulario.marca === 'X') {
      delete data.formulario.marca;
    }
        
    const formulario = new FormData();
    formulario.append("data", JSON.stringify(data.formulario));
    
    let nombre = data.formulario.nombre;
    let mail = data.formulario.email;
    let codigo = data.aviso.NumAviso;

    this.apiService.AgregarContacto(formulario).subscribe(res => {
      if (res.respuesta === true) {
        this.dialogRef.close();
        this.sendEmail(nombre ,mail, codigo );
        //alert('Consulta enviada nuevamente.');
        //this.router.navigate(['/home']);
        this.dialogRef.close({ exito: true, aviso: data.aviso });  
      }
      else {
        alert('Envio fallido, intentelo nuevamente.');
      }
    });
  }

  onExit(): void {
    this.router.navigate(['/home']);
    this.dialogRef.close();  
  }

  sendEmail(nombre: string, mail: string, requestId: string) {
    this.apiService.sendEmail(nombre, mail, requestId).subscribe(
        response => {
        //console.log('Email Enviado', response);
      },
      error => {
        console.error('Error enviando email', error);
      }
    );
  }

}
